import { render, staticRenderFns } from "./_base-delete-button.vue?vue&type=template&id=bcfe7a70&scoped=true&"
import script from "./_base-delete-button.vue?vue&type=script&lang=js&"
export * from "./_base-delete-button.vue?vue&type=script&lang=js&"
import style0 from "./_base-delete-button.vue?vue&type=style&index=0&id=bcfe7a70&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfe7a70",
  null
  
)

export default component.exports